/* eslint-disable prefer-destructuring */
/* eslint-disable class-methods-use-this */
/* eslint-disable max-classes-per-file */
const bundleLookColorHandle = (value) =>
  String(value || '')
    .toLowerCase()
    .replace(/\s/g, '-');

const bundleCache = new Map();

class UpsellProductsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-upsell-products-tab]')];
    this.panels = [...this.querySelectorAll('[data-upsell-products-panel]')];
    this.nav = this.querySelector('.upsell-products-tabs__nav');
    this.setPanel = this.querySelector('[data-upsell-products-panel="set"]') || this.panels[0];
    this.sliderPanel = this.querySelector('[data-upsell-products-panel="slider"]') || this.panels[1];
    this.setTab = this.querySelector('[data-upsell-products-tab="set"]') || this.tabs[0];
    this.similarTab = this.querySelector('[data-upsell-products-tab="similar"]') || this.tabs[1];
    this.quickAdd = this.querySelector('upsell-set-quick-add');
    this.container = this.closest('.upsell__products');
    this.section = this.closest('[data-section-id]');
    this.product = this.closest('[data-product]');
    this.productForm = this.product?.querySelector('[data-product-form]');
    this.candidates = JSON.parse(this.querySelector('[data-upsell-set-candidates]')?.textContent || '[]');
    this.onVariantChange = (event) => this.handleVariantChange(event);
    this.onOptionChange = (event) => this.handleOptionChange(event);
    this.pendingColorHandle = '';
    this.pendingColorLabel = '';
    this.colorChangeFrame = null;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
    });

    this.onSetUnavailable = () => this.showSliderOnly();

    document.addEventListener('theme:variant:change', this.onVariantChange);
    this.productForm?.addEventListener('change', this.onOptionChange);
    this.addEventListener('upsell-set:unavailable', this.onSetUnavailable);
    this.scheduleApplyColor(this.dataset.selectedColor, this.dataset.selectedColorLabel);
  }

  disconnectedCallback() {
    document.removeEventListener('theme:variant:change', this.onVariantChange);
    this.productForm?.removeEventListener('change', this.onOptionChange);
    this.removeEventListener('upsell-set:unavailable', this.onSetUnavailable);
    if (this.colorChangeFrame) window.cancelAnimationFrame(this.colorChangeFrame);
  }

  handleVariantChange(event) {
    const eventSection = event.target?.closest?.('[data-section-id]');
    if (this.section && eventSection && eventSection !== this.section) return;

    this.scheduleApplyColor(
      bundleLookColorHandle(event.detail?.variant?.option1),
      event.detail?.variant?.option1 || '',
    );
  }

  handleOptionChange(event) {
    const option = event.target.closest('[data-single-option-selector]');
    const swatchButton = option?.closest('[data-swatches-button]');

    if (!option || !swatchButton) return;

    const colorLabel = swatchButton.dataset.swatch || option.value || '';
    this.scheduleApplyColor(bundleLookColorHandle(colorLabel), colorLabel);
  }

  scheduleApplyColor(colorHandle, colorLabel = '') {
    this.pendingColorHandle = colorHandle || this.pendingColorHandle;
    this.pendingColorLabel = colorLabel || this.pendingColorLabel;

    if (this.colorChangeFrame) window.cancelAnimationFrame(this.colorChangeFrame);

    this.colorChangeFrame = window.requestAnimationFrame(() => {
      this.colorChangeFrame = null;
      const selectedColorLabel = this.getSelectedColorLabel();
      const selectedColorHandle = bundleLookColorHandle(selectedColorLabel);
      this.applyColor(selectedColorHandle || this.pendingColorHandle, selectedColorLabel || this.pendingColorLabel);
    });
  }

  getSelectedColorLabel() {
    const selectedSwatch = this.productForm?.querySelector(
      '[data-swatches-button] input[data-single-option-selector]:checked',
    );
    const swatchButton = selectedSwatch?.closest('[data-swatches-button]');

    if (!selectedSwatch || !swatchButton) return '';

    return swatchButton.dataset.swatch || selectedSwatch.value || '';
  }

  applyColor(colorHandle, colorLabel = '') {
    const matchingSet = this.findMatchingSet(colorHandle);

    if (!matchingSet) {
      this.showSliderOnly();
      return;
    }

    this.showTabs(matchingSet.handle, colorHandle, colorLabel);
  }

  selectTab(activeTab) {
    let activePanel = null;

    this.tabs.forEach((tab) => {
      const isActive = tab === activeTab;
      const panel = this.querySelector(`#${tab.getAttribute('aria-controls')}`);

      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (panel) {
        panel.hidden = !isActive;
        if (isActive) activePanel = panel;
      }
    });

    this.refreshVisibleSlider(activePanel);
  }

  findMatchingSet(colorHandle) {
    if (!colorHandle) return null;

    const exact = this.candidates.find((candidate) => candidate.color && candidate.color === colorHandle);
    if (exact) return exact;

    return this.candidates.find((candidate) => this.handleMatchesColor(candidate.handle, colorHandle)) || null;
  }

  handleMatchesColor(handle, colorHandle) {
    if (!handle || !colorHandle) return false;

    return handle === colorHandle || handle.startsWith(`${colorHandle}-`);
  }

  showTabs(setHandle, colorHandle, colorLabel = '') {
    this.container?.classList.add('upsell__products--tabs');
    if (this.nav) this.nav.hidden = false;
    if (this.setPanel) this.setPanel.hidden = false;
    if (this.sliderPanel) this.sliderPanel.hidden = true;

    if (this.setTab) this.setTab.setAttribute('aria-selected', 'true');
    if (this.similarTab) this.similarTab.setAttribute('aria-selected', 'false');
    if (this.quickAdd) {
      this.quickAdd.hidden = false;
      this.quickAdd.setHandle(setHandle, colorHandle, colorLabel);
    }
  }

  showSliderOnly() {
    this.container?.classList.remove('upsell__products--tabs');
    if (this.nav) this.nav.hidden = true;
    if (this.setPanel) this.setPanel.hidden = true;
    if (this.sliderPanel) {
      this.sliderPanel.hidden = false;
      this.refreshVisibleSlider(this.sliderPanel);
    }
    if (this.quickAdd) this.quickAdd.hidden = true;
  }

  refreshVisibleSlider(panel) {
    if (!panel) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const slider = panel.querySelector('[data-upsell-slider]');
        const Flickity = window.themeVendor?.Flickity;
        const flkty = slider && Flickity?.data ? Flickity.data(slider) : null;

        if (flkty) {
          flkty.reloadCells();
          flkty.resize();
          flkty.reposition();
        }
      });
    });
  }
}

class UpsellSetQuickAdd extends HTMLElement {
  connectedCallback() {
    if (this.dataset.setHandle && !this.querySelector('[data-upsell-set-variants]')) {
      this.loadBundleChild();
      return;
    }

    this.bindForm();
  }

  setHandle(setHandle, colorHandle = '', colorLabel = '') {
    if (!setHandle) return;

    const normalizedColorHandle = colorHandle || this.dataset.colorHandle || '';
    const normalizedColorLabel = colorLabel || this.dataset.colorLabel || '';

    if (
      this.dataset.setHandle === setHandle &&
      this.dataset.colorHandle === normalizedColorHandle &&
      this.dataset.colorLabel === normalizedColorLabel &&
      this.querySelector('[data-upsell-set-variants]')
    ) {
      return;
    }

    this.dataset.setHandle = setHandle;
    this.dataset.colorHandle = normalizedColorHandle;
    this.dataset.colorLabel = normalizedColorLabel;

    this.classList.add('upsell-set-quick-add--loading');
    this.loadBundleChild(setHandle, normalizedColorHandle, normalizedColorLabel);
  }

  async loadBundleChild(
    setHandle = this.dataset.setHandle,
    colorHandle = this.dataset.colorHandle || '',
    colorLabel = this.dataset.colorLabel || '',
  ) {
    if (!setHandle) return;
    if (this.abortController) this.abortController.abort();

    this.setAttribute('aria-busy', 'true');

    try {
      let bundle = bundleCache.get(setHandle);

      if (!bundle) {
        this.abortController = new AbortController();
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${setHandle}?view=bundle`, {
          signal: this.abortController.signal,
        });
        if (!response.ok) throw new Error(`Failed to load bundle ${setHandle}: ${response.status}`);
        bundle = await response.json();
        bundleCache.set(setHandle, bundle);
      }
      const product = this.getQuickAddProduct(bundle?.children || []);

      if (
        this.dataset.setHandle !== setHandle ||
        this.dataset.colorHandle !== colorHandle ||
        this.dataset.colorLabel !== colorLabel
      ) {
        return;
      }

      if (!product) {
        this.markUnavailable();
        return;
      }

      this.renderProduct(product, colorHandle, colorLabel);
      this.bindForm();
    } catch (error) {
      if (error?.name === 'AbortError') return;

      this.markUnavailable();
    } finally {
      if (
        this.dataset.setHandle === setHandle &&
        this.dataset.colorHandle === colorHandle &&
        this.dataset.colorLabel === colorLabel
      ) {
        this.removeAttribute('aria-busy');
        this.classList.remove('upsell-set-quick-add--loading');
      }
    }
  }

  getQuickAddProduct(children) {
    const mainProductType = String(this.dataset.mainProductType || '').toLowerCase();

    return (
      children.find((child) => String(child?.type || '').toLowerCase() !== mainProductType) ||
      children[1] ||
      children[0]
    );
  }

  markUnavailable() {
    this.hidden = true;
    // Tell the parent tabs there is no set to show so it can fall back to the slider
    // instead of leaving an empty, selected "Complete the set" tab.
    this.dispatchEvent(new CustomEvent('upsell-set:unavailable', { bubbles: true }));
  }

  detectSizeOptionIndex(optionNames) {
    const sizeLabels = (this.dataset.sizeNames || '')
      .split(',')
      .map((label) => this.handleize(label))
      .filter(Boolean);

    let index = sizeLabels.length ? optionNames.findIndex((name) => sizeLabels.includes(this.handleize(name))) : -1;

    if (index < 0) {
      index = optionNames.findIndex((name) => /size|größe|taille|taglia|rozmiar|maat/i.test(name));
    }

    return Math.max(index, 0);
  }

  renderProduct(product, colorHandle = this.dataset.colorHandle || '', colorLabel = this.dataset.colorLabel || '') {
    const cardTemplate = this.querySelector('template[data-upsell-set-card]');

    if (!cardTemplate) {
      this.markUnavailable();
      return;
    }

    const variants = product.variants || [];
    const colorVariants = colorHandle
      ? variants.filter((variant) => bundleLookColorHandle(this.getVariantOption(variant, 0)) === colorHandle)
      : variants;
    const scopedVariants = colorVariants.length ? colorVariants : variants;
    const selectedVariant = scopedVariants.find((variant) => variant.available) || scopedVariants[0];
    const optionNames = product.options || [];
    const sizeOptionIndex = this.detectSizeOptionIndex(optionNames);
    const sizeOptionName = optionNames[sizeOptionIndex] || 'Size';
    const sizeValues = [
      ...new Set(scopedVariants.map((variant) => this.getVariantOption(variant, sizeOptionIndex)).filter(Boolean)),
    ];
    const image = selectedVariant?.featured_image?.src || product.featured_image || product.images?.[0] || '';
    const compareAtPrice =
      selectedVariant?.compare_at_price > selectedVariant?.price ? selectedVariant.compare_at_price : null;
    const titleLabel = colorLabel || this.getVariantOption(selectedVariant, 0) || '';
    const displayTitle = titleLabel ? `${product.title} - ${titleLabel}` : product.title;
    const discountPercent = compareAtPrice
      ? Math.round(((compareAtPrice - selectedVariant.price) * 100) / compareAtPrice)
      : 0;
    const productUrl = product.url || `/products/${product.handle}`;
    const available = Boolean(selectedVariant?.available);

    const card = cardTemplate.content.cloneNode(true);

    const imageLink = card.querySelector('[data-slot-image-link]');
    if (imageLink) imageLink.href = productUrl;

    const img = card.querySelector('[data-slot-image]');
    if (img) {
      if (image) {
        img.src = this.sizedImageUrl(image, 360);
        img.alt = product.title || '';
      } else {
        img.remove();
      }
    }

    const title = card.querySelector('[data-slot-title]');
    if (title) {
      title.href = productUrl;
      title.textContent = displayTitle;
    }

    const badge = card.querySelector('[data-slot-badge]');
    if (badge) {
      if (discountPercent) {
        badge.textContent = `-${discountPercent}%`;
        badge.hidden = false;
      } else {
        badge.remove();
      }
    }

    const priceWrap = card.querySelector('[data-slot-price-wrap]');
    if (priceWrap) priceWrap.classList.toggle('upsell-set-quick-add__price--sale', Boolean(discountPercent));

    const compare = card.querySelector('[data-slot-compare]');
    if (compare) {
      compare.textContent = compareAtPrice ? this.formatMoney(compareAtPrice) : '';
      compare.hidden = !compareAtPrice;
    }

    const price = card.querySelector('[data-slot-price]');
    if (price) price.textContent = this.formatMoney(selectedVariant?.price || product.price || 0);

    const variantId = card.querySelector('[data-upsell-set-variant-id]');
    if (variantId) variantId.value = selectedVariant?.id || '';

    const legend = card.querySelector('[data-slot-legend]');
    if (legend) legend.textContent = sizeOptionName;

    const optionsField = card.querySelector('[data-slot-options]');
    const optionTemplate = card.querySelector('template[data-upsell-set-option-template]');
    if (optionsField && optionTemplate && sizeValues.length) {
      sizeValues.forEach((value) => {
        const valueVariant = scopedVariants.find(
          (variant) => this.getVariantOption(variant, sizeOptionIndex) === value && variant.available,
        );
        const id = `upsell-set-${product.id}-${this.handleize(value)}`;
        const option = optionTemplate.content.cloneNode(true);
        const input = option.querySelector('input');
        const label = option.querySelector('label');

        if (input) {
          input.id = id;
          input.name = `options[${sizeOptionName}]`;
          input.value = value;
          input.dataset.optionIndex = String(sizeOptionIndex);
          input.disabled = !valueVariant;
        }
        if (label) {
          label.htmlFor = id;
          label.textContent = value;
        }
        optionsField.appendChild(option);
      });
    }

    if (optionTemplate) optionTemplate.remove();
    if (optionsField && !sizeValues.length) optionsField.remove();

    const button = card.querySelector('[data-add-to-cart]');
    if (button) {
      const buttonClasses = (this.dataset.buttonClasses || 'btn-new-primary btn--solid btn--large')
        .split(/\s+/)
        .filter(Boolean);
      button.classList.add(...buttonClasses);
      button.disabled = !available;
    }

    const buttonText = card.querySelector('[data-upsell-add-to-cart-text]');
    if (buttonText) buttonText.textContent = this.dataset.buttonLabel || 'Größe auswählen';

    const variantsScript = card.querySelector('[data-upsell-set-variants]');
    if (variantsScript) {
      variantsScript.textContent = JSON.stringify(
        variants.map((variant) => ({
          id: variant.id,
          available: variant.available,
          price: this.formatMoney(variant.price),
          compare_at_price:
            variant.compare_at_price > variant.price ? this.formatMoney(variant.compare_at_price) : null,
          options: variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean),
        })),
      );
    }

    [...this.children].forEach((child) => {
      if (child !== cardTemplate) child.remove();
    });
    this.appendChild(card);
  }

  bindForm() {
    this.variants = JSON.parse(this.querySelector('[data-upsell-set-variants]')?.textContent || '[]');
    this.variantInput = this.querySelector('[data-upsell-set-variant-id]');
    this.price = this.querySelector('[data-upsell-set-price]');
    this.comparePrice = this.querySelector('[data-upsell-set-compare-price]');
    this.button = this.querySelector('[data-add-to-cart]');
    this.buttonText = this.button?.querySelector('[data-upsell-add-to-cart-text]');

    this.querySelectorAll('[data-upsell-set-option]').forEach((option) => {
      option.addEventListener('change', () => this.updateVariant(option));
    });
  }

  updateVariant(option) {
    const optionIndex = Number(option.dataset.optionIndex);
    const variant = this.variants.find((item) => {
      const colorMatches = this.dataset.colorHandle
        ? bundleLookColorHandle(item.options?.[0]) === this.dataset.colorHandle
        : true;

      return colorMatches && item.options?.[optionIndex] === option.value;
    });

    if (!variant) return;

    if (this.variantInput) this.variantInput.value = variant.id;
    if (this.price) this.price.textContent = variant.price;
    if (this.comparePrice) {
      this.comparePrice.textContent = variant.compare_at_price || '';
      this.comparePrice.hidden = !variant.compare_at_price;
    }
    if (this.button) this.button.disabled = !variant.available;
    if (this.button && variant.available) this.button.removeAttribute('data-select-size');
    if (this.buttonText && variant.available) this.buttonText.textContent = this.dataset.addLabel || 'Add to cart';
  }

  getVariantOption(variant, optionIndex) {
    return variant.options?.[optionIndex] || variant[`option${optionIndex + 1}`];
  }

  formatMoney(cents) {
    const amount = Number(cents || 0);

    if (window.themeVendor?.themeCurrency?.formatMoney) {
      return window.themeVendor.themeCurrency.formatMoney(amount, window.theme?.moneyFormat);
    }

    // Fallback when the currency vendor is unavailable: use the store's money format
    // template rather than hardcoding a currency symbol (which is wrong for non-EUR markets).
    const value = (amount / 100).toFixed(2);
    const format = window.theme?.moneyFormat;
    return format ? format.replace(/\{\{\s*amount\s*\}\}/, value) : value;
  }

  sizedImageUrl(src, width) {
    if (!src) return '';

    try {
      const url = new URL(src, window.location.origin);
      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (error) {
      return src;
    }
  }

  handleize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }
}

if (!customElements.get('upsell-products-tabs')) {
  customElements.define('upsell-products-tabs', UpsellProductsTabs);
}

if (!customElements.get('upsell-set-quick-add')) {
  customElements.define('upsell-set-quick-add', UpsellSetQuickAdd);
}
